import { useEffect, useState } from "react";

export const useFetchProductSettingsDistributorOverrides = (sku) => {
    const [productSettingsDistributorsOverrides, setProductSettingsDistributorsOverrides] = useState([]);

    useEffect(() => {
        const fetchProductSettingsDistributorOverrides = async () => {
            const rsp = await fetch(`api/products/${sku}/distributors`);
            const productSettingsDistributorsOverrides = await rsp.json();

            setProductSettingsDistributorsOverrides(productSettingsDistributorsOverrides);
        }
        fetchProductSettingsDistributorOverrides();
    }, [sku])

    return productSettingsDistributorsOverrides;
}

export const PutProductSettingDistributorOverride = async (product, distributorRow) => {
    const controller = new AbortController();
    const signal = controller.signal;

    const productSettingDistributorOverrideDto = {
        templateItemID: distributorRow.templateItemID,
        itemId: product.itemId,
        distributorId: distributorRow.id,
        palletQuantity: Number.parseInt(distributorRow.palletQuantity),
        palletDivisor: Number.parseInt(distributorRow.palletDivisor),
        unitWeight: Number.parseFloat(distributorRow.unitWeight)
    }

    // PUT request using fetch with error handling
    const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(productSettingDistributorOverrideDto),
        signal: signal,
    };

    try {
        const response = await fetch(`api/products/productSettingsDistributorOverride`, requestOptions);
        if (!response.ok) {
            await response.json();
        }
    } catch (error) {
        console.error('Error:', error);
    }
}

export const PutProductDistributorOfferingStatus = async (product, distributorRow) => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (distributorRow.skuOfferingStatus && distributorRow.skuOfferingStatus.id) {
        // PUT request using fetch with error handling
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(distributorRow.skuOfferingStatus.id),
            signal: signal,
        };

        try {
            const response = await fetch(`api/products/${product.sku}/${distributorRow.id}/offeringStatus`, requestOptions);
            if (!response.ok) {
                await response.json();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }
}

export const PutProductDistributorFulfillmentType = async (product, distributorRow, directDistributorId = null, inMarketOptions) => {
    const controller = new AbortController();
    const signal = controller.signal;

    const payload = {
        fulfillmentType: distributorRow.skuFulfillmentType.id,
        directDistributorId: directDistributorId
    };
    if (inMarketOptions !== undefined && inMarketOptions !== null) {
        // Only touch the field(s) the caller actually supplied, so an end-date edit
        // does not clear the in-market date (and vice versa).
        if ('setInMarketDate' in inMarketOptions || 'inMarketDate' in inMarketOptions) {
            payload.setInMarketDate = inMarketOptions.setInMarketDate !== false;
            payload.inMarketDate = inMarketOptions.inMarketDate;
        }
        if ('setEndInMarketDate' in inMarketOptions || 'endInMarketDate' in inMarketOptions) {
            payload.setEndInMarketDate = inMarketOptions.setEndInMarketDate !== false;
            payload.endInMarketDate = inMarketOptions.endInMarketDate;
        }
    }

    // PUT request using fetch with error handling
    const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        signal: signal,
    };

    try {
        const response = await fetch(`api/products/${product.sku}/${distributorRow.id}/fulfillmentType`, requestOptions);
        if (response.ok) {
            return { ok: true, error: null };
        }

        // Surface the reason a save was rejected (e.g. a date-bound validation) to the caller. The
        // controller returns the message as plain text (StringOutputFormatter), but tolerate a JSON
        // string or a ProblemDetails body too.
        let error = null;
        try {
            const text = await response.text();
            if (text) {
                try {
                    const body = JSON.parse(text);
                    error = typeof body === 'string' ? body : (body?.detail || body?.title || text);
                } catch {
                    error = text;
                }
            }
        } catch {
            error = null;
        }
        return { ok: false, error };
    } catch (error) {
        console.error('Error:', error);
        return { ok: false, error: null };
    }
}